/**
 * The order measurement types take as group headers in a unit picker.
 *
 * By how often a merchant reaches for one: things are counted first, then weighed,
 * then poured, then measured out. A type absent from this list — one a tenant
 * created — follows the named ones, ordered by its own label.
 *
 * The values are `measurement_unit_types.type`, which reaches the client as
 * `MeasurementUnitType.unit_identifier`. The authoritative list is
 * `Domain\Products\Enums\MeasurementUnitTypeEnum` together with the `TYPE_*`
 * constants on `Support\Measurement\Models\MeasurementUnitType`.
 *
 * ⚠ `custom` is left out on purpose. It is the type a tenant's own units land
 * under, so it belongs after the standard ones rather than among them.
 */
const MEASUREMENT_TYPE_ORDER = ['item', 'count', 'weight', 'volume', 'length'] as const

/**
 * The types whose units count things rather than measure them, and so agree with a number.
 *
 * Only these pluralise. `kg` is `kg` at any quantity, and a unit under a tenant's own `custom`
 * type has no spelling we can predict, so it keeps its symbol untouched.
 */
// `readonly string[]`, not `as const`: `.includes(type_id)` takes a `string`, which a literal tuple refuses.
const COUNTING_MEASUREMENT_TYPES: readonly string[] = ['item', 'count']

export { COUNTING_MEASUREMENT_TYPES, MEASUREMENT_TYPE_ORDER }
